$(document).ready(function () {
    $("#page-login main").removeClass("container");
    $("#page-login main").removeClass("my-4");

    function togglePassword($btn) {
        const shown = $("#login_password").attr("type") !== "password";

        $("#login_password").attr("type", shown ? "password" : "text");
        $btn.toggleClass("active", !shown);
        // The control is a button to screen readers, so it has to say which
        // state it is in as well as look like it.
        $btn.attr("aria-pressed", String(!shown));
    }

    $(".b-toggle-password").on("click", function () {
        togglePassword($(this));
    });

    // Reachable by keyboard, not just by mouse.
    $(".b-toggle-password").on("keydown", function (e) {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
            e.preventDefault();
            togglePassword($(this));
        }
    });
})